export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 1_02.c6bdfb05.jpg";